import { useTranslation } from "react-i18next";
import { Route } from "../../models/routing.model";
import { NavLink } from "react-router-dom";
import { Button } from "primereact/button";
import { useState } from "react";
import { Sidebar } from "primereact/sidebar";
import { classNames } from "primereact/utils";
import { useAuth0 } from "@auth0/auth0-react";
import { MatomoAction, MatomoCategory } from "../../models/matomo.model";
import { useMatomo } from "@jonkoops/matomo-tracker-react";
import { MatomoService } from "../../services/matomo/matomo.service";
import { ThemeService } from "../../services/theme/ThemeService.service";

const HeaderResponsive = ({ routes }: { routes: Route[] }) => {
	const { t } = useTranslation("common");
	const [showMenu, setShowMenu] = useState(false);
	const { logout } = useAuth0();
	const matomo = useMatomo();

	const sendTabEvent = (routeId: string) => {
		const event = MatomoService.getTabEvent(routeId);
		if (event) {
			matomo.trackEvent({
				category: event.category,
				action: event.action,
			});
		}
	};

	return (
		<>
			<header className="topbar-responsive">
				{/* Logo */}
				<NavLink
					to="/"
					className="topbar-responsive__link"
				>
					<img
						alt={ThemeService.setIconAlt()}
						src={ThemeService.setIcon()}
					/>
				</NavLink>

				<Button
					type="button"
					icon="pi pi-bars"
					className="topbar-responsive__button"
					onClick={() => setShowMenu(!showMenu)}
				/>
			</header>
			<Sidebar
				visible={showMenu}
				showCloseIcon={false}
				onHide={() => setShowMenu(false)}
				maskClassName="topbar-responsive__sidebar"
			>
				{/* Menu options */}
				<ul className="topbar-responsive__menu">
					{/* Iterate the menu options */}
					{routes
						.filter((item) => item.routeProps.isVisible !== false)
						.map((item) => (
							<li key={`${item.routeProps.id}`}>
								<NavLink
									to={`${item.route.path}`}
									className={({ isActive }) =>
										classNames(
											"topbar-responsive__menu__item",
											isActive && "is-active"
										)
									}
									onClick={() => {
										setShowMenu(false);
										sendTabEvent(item.routeProps.id);
									}}
								>
									{t(`${item.routeProps.title}`)}
								</NavLink>
							</li>
						))}
				</ul>

				<div className="topbar-responsive__footer">
					<Button
						type="button"
						label={t("UI_COMPONENTS.HEADER.LOGOUT")}
						className="topbar-responsive__footer__logout"
						onClick={() => {
							setShowMenu(false);
							matomo.trackEvent({
								category: MatomoCategory.AUTHENTICATION,
								action: MatomoAction.LOGOUT,
							});
							logout({
								logoutParams: {
									returnTo: window.location.origin + "/login",
								},
							});
						}}
					/>
				</div>
			</Sidebar>
		</>
	);
};
export default HeaderResponsive;
